<template>
  <div>
    <page-loading v-if="!station" />
    <b-row v-if="station">
      <b-col sm="6">
        <page-title :title="pageTitle" :hideHome="true" />
        <b-link to="/">View All Stations</b-link>
      </b-col>
      <b-col sm="6" class="text-right">
        <h2 class="mt-4">{{pageDate}}</h2>
        <b-link :to="prevMonthUrl">&lt; {{getMonthYearForUser(prevMonth.toISOString())}}</b-link> |
        <b-link :to="nextMonthUrl">{{getMonthYearForUser(nextMonth.toISOString())}} &gt;</b-link>
      </b-col>
    </b-row>
    <b-row v-for="week in weeks" v-if="station">
      <b-col>
        <b-card-group>
          <b-card v-for="day in week">
            <template v-slot:header>
              <span class="float-left" v-if="formatDateForData(day.date) == formatDateForData(startDate) || day.date.getDate() == 1">{{getMonthName(day.date.toISOString())}}</span>
              <div class="text-right">
                <span v-if="day.allergenCollectionSet">
                  <b-link :to="'/station/' + stationId + '/allergenCollectionSet/' + day.allergenCollectionSet.id">
                    {{day.date.getDate()}}
                  </b-link>
                </span>
                <span v-if="!day.allergenCollectionSet">
                  {{day.date.getDate()}}
                </span>
              </div>
            </template>
            <b-card-text>
              <div v-if="day.allergenCollectionSet">
                <div v-for="category in categories" v-bind:key="category.name">
                  {{category.displayName}} <span class="small"><b-badge pill :variant="getCategorySettings(station, day.allergenCollectionSet, category).backgroundColor">{{getCategorySettings(station, day.allergenCollectionSet, category).shortLabel}}</b-badge></span>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'
import AllergenCollectionMixins from '../Common/AllergenCollectionMixins.js'
import DateTimeMixins from '../Common/DateTimeMixins.js'

export default {
  name: "StationCalendar",
  mixins: [
    CrudOperationsMixin, 
    AllergenCollectionMixins,
    DateTimeMixins
  ],
  props: [
  ],
  data() {
    return {
      stationId: null,
      station: null,
      items: null,
      year: null,
      month: null,
      startDate: null,
      endDate: null,
      nextDate: null,
      weeks: []
    };
  },
  computed: {
    pageTitle: function () {
      return this.station.displayCity + ', ' + this.station.state;
    },
    pageDate: function () {
      return this.getMonthYearForUser(new Date(this.year + '-' + this.month + '-1'));
    },
    nextMonth: function () {
      let d = new Date(this.year + '-' + this.month + '-1');
      d.setMonth(d.getMonth() + 1);
      return d;
    },
    prevMonth: function () {
      let d = new Date(this.year + '-' + this.month + '-1');
      d.setMonth(d.getMonth() - 1);
      return d;
    },
    nextMonthUrl: function () {
      let d = this.nextMonth;
      return '/station/' + this.stationId + '/calendar/' + d.getFullYear() + '/' + (d.getMonth() + 1);
    },
    prevMonthUrl: function () {
      let d = this.prevMonth;
      return '/station/' + this.stationId + '/calendar/' + d.getFullYear() + '/' + (d.getMonth() + 1);
    }
  },
  methods: {
    updateDates: function () {
      this.startDate = new Date(this.year + '/' + this.month + '/1');
      while (this.startDate.getDay() != 0)
        this.startDate.setDate(this.startDate.getDate() - 1);

      this.endDate = new Date(this.year + '/' + this.month + '/1');
      this.endDate.setMonth(this.endDate.getMonth() + 1);
      this.endDate.setDate(this.endDate.getDate() - 1);
      while (this.endDate.getDay() != 6)
        this.endDate.setDate(this.endDate.getDate() + 1);

      this.nextDate = new Date(this.endDate);
      this.nextDate.setDate(this.nextDate.getDate() + 1);

      this.weeks = [];
      for (let d = new Date(this.startDate); d <= this.endDate; d.setDate(d.getDate() + 1)) {
        let week = this.weeks[this.weeks.length - 1];
        if (!week || week.length == 7) {
          week = [];
          this.weeks.push(week);
        }

        week.push({
          date: new Date(d)
        });
      }
    },
    load: function () {
      this.stationId = this.$route.params.id;

this.year = parseInt(this.$route.params.year);
      this.month = parseInt(this.$route.params.month);

      if (!this.year)
        this.year = 2019;
      if (!this.month)
        this.month = 5;
        
      this.updateDates();
      this.loadAllergenCollectionSet();
    },
    getAllergenCollectionSet: function (date) {
      if (!this.items)
        return null;

      let dateString = this.formatDateForData(date);

      let x = this.items.filter(x => x.date == dateString);
      if (!x || x.length == 0)
        return null;

      return x[0];
    },
    loadAllergenCollectionSet: function () {
      this.readQuery('/graphql/public', {
          query: `
            query ($id: ID, $filter: String) {
              station (id: $id) {
                name,
                name2,
                displayCity,
                state,
                country,
                scaleSet {
                  id,
                  scales {
                    id,
                    category,
                    range1Begin,
                    range2Begin,
                    range3Begin,
                    range4Begin
                  }
                }
              },
              allergenCollectionSets (filter: $filter, limit: 50) {
                id,
                date,
                allergenCollections {
                  id,
                  value,
                  allergen {
                    id,
                    name,
                    commonName,
                    family,
                    category
                  }
                }
              }
            }`,
          variables: {
            'id': this.stationId,
            'filter': 'stationId = "' + this.stationId + '" and date >= "' + this.formatDateForData(this.startDate) + '" and date < "' + this.formatDateForData(this.nextDate) + '"'
          }
        }, (data) => {
          this.station = data.station;
          this.items = data.allergenCollectionSets;

          this.weeks.forEach(week => {
            week.forEach(day => {
              let x = this.items.filter(i => i.date == this.formatDateForData(day.date));
              if (x && x.length > 0)
                day.allergenCollectionSet = x[0];
            })
          })
        });        
    }    
  },
  mounted () {
    this.load();
  },
  watch:{
    $route (to, from) {
      this.load();
    }
  }   
};
</script>